export default "/images/cat-youtube.png?dc54e158230a669812d39b9e2e14d782";